import {
	EvComboboxOption,
	Globe,
	IFilterDefinition,
	IFilterValues,
	User
} from '@evinced-private/ui-common';

import { IFilterOptions } from '../../../components/data-filter/DataFilterHelper';
import { CollectionTypeLabels, CollectionTypes, ICollection } from '../../../interfaces/Collection';
import { COMPARE_TYPE, COMPARE_TYPE_OPTIONS_LABELS } from '../DashboardTypes';

export const DASHBOARD_FILTERS_ID = 'dashboard-filters';

const lastScansLiftPeriod = {
	label: COMPARE_TYPE_OPTIONS_LABELS[COMPARE_TYPE.COMPARE_LAST_SCANS],
	value: COMPARE_TYPE.COMPARE_LAST_SCANS
};

const dateRangeLiftPeriod = {
	label: COMPARE_TYPE_OPTIONS_LABELS[COMPARE_TYPE.COMPARE_DATE_RANGE],
	value: COMPARE_TYPE.COMPARE_DATE_RANGE
};

export const defaultFilterValues = {
	collections: [],
	liftPeriods: [lastScansLiftPeriod]
};

export const liftPeriodOptions = [lastScansLiftPeriod, dateRangeLiftPeriod];

export const getFilterDefinitions = (): IFilterDefinition[] => {
	const filterDefinitions: IFilterDefinition[] = [
		{
			id: 'collections',
			label: 'Select Collections',
			filterType: 'select',
			defaultValue: defaultFilterValues.collections,
			width: '288px',
			componentProps: {
				id: 'collections',
				label: 'Collections',
				isMultiple: true,
				placeholder: 'Select Collections',
				listboxWidth: '288px',
				allSelectedPlaceholder: 'All Collections',
				someItemsSelectedText: (count: number) => `Collections (${count})`,
				className: 'collections-filter',
				groups: [
					{
						id: CollectionTypes.USER,
						name: CollectionTypeLabels.USER,
						icon: User
					},
					{
						id: CollectionTypes.TENANT,
						name: CollectionTypeLabels.TENANT,
						icon: Globe
					}
				]
			}
		},
		{
			id: 'liftPeriods',
			label: 'Compared to',
			filterType: 'select',
			defaultValue: defaultFilterValues.liftPeriods,
			width: '140px',
			componentProps: {
				id: 'liftPeriodsCompare',
				label: 'Compared to',
				isMultiple: false,
				placeholder: 'Select',
				listboxWidth: '140px',
				className: 'lift-period-filter'
			}
		}
	];

	return filterDefinitions;
};

export const getInitialFilterValues = ({
	appliedFilters,
	propertyCollections,
	isCollectionsLoading
}: {
	appliedFilters?: IFilterOptions;
	propertyCollections?: ICollection[];
	isCollectionsLoading?: boolean;
}): IFilterValues => {
	if (isCollectionsLoading) {
		return {
			text: {},
			select: {
				collections: appliedFilters?.collections || defaultFilterValues.collections,
				liftPeriods: appliedFilters?.liftPeriods || defaultFilterValues.liftPeriods
			}
		};
	}

	// Removing non-existent collections from filters
	const collectionsForFilters = appliedFilters?.collections?.filter((filterCollection) => {
		return !!propertyCollections.find((collection) => collection.id === filterCollection.value);
	});

	return {
		text: {},
		select: {
			collections: collectionsForFilters || defaultFilterValues.collections,
			liftPeriods: appliedFilters?.liftPeriods || defaultFilterValues.liftPeriods
		}
	};
};

export const mapCollectionsToOptions = (collections: ICollection[]): EvComboboxOption[] => {
	if (!collections || !collections?.length) {
		return [];
	}

	return collections.map((collection) => ({
		label: collection.name,
		value: collection.id,
		groupId: collection.type
	}));
};
